import React from 'react';
import QuickNavSearchControls from '../Pharmacy/PharmacyPlan/QuickNavSearchControls';
import { QUICK_NAV_STICKY_SEARCH_CONTROLS_STYLE } from './CompareQuickNavOverlay.styles';

interface IQuickNavStickySearchBarProps {
    isHidden: boolean;
    backgroundColor: string;
    showDifferencesOnly: boolean;
    showDifferencesOnlyDisabled?: boolean;
    onSearch: (query: string | null) => void;
    onShowDifferencesOnlyChange: (checked: boolean) => void;
}

// the sticky search/filter bar shared by both the embedded sidebar and the floating panel
const QuickNavStickySearchBar: React.FC<IQuickNavStickySearchBarProps> = (props) => (
    <div
        style={{
            ...QUICK_NAV_STICKY_SEARCH_CONTROLS_STYLE,
            backgroundColor: props.backgroundColor,
            zIndex: 1000,
        }}
    >
        <QuickNavSearchControls
            isHidden={props.isHidden}
            mountOnce={true}
            showDifferencesOnly={props.showDifferencesOnly}
            showDifferencesOnlyDisabled={props.showDifferencesOnlyDisabled}
            onSearch={props.onSearch}
            onShowDifferencesOnlyChange={props.onShowDifferencesOnlyChange}
        />
    </div>
);

export default QuickNavStickySearchBar;
